import {useState} from 'react'
import loadingGif from '../../assets/loading.gif';
import GetYourPizza from './GetYourPizza';
import FormSuccess from './FormSuccess'
export default function Form() {
const [isSubmmitted,setIsSubmitted] = useState(false);
const [loading, setLoading] = useState(false);

const loadingIcon = () => {
  setLoading(true)
}

const submitForm = () : void => {
    setIsSubmitted(true);
    setLoading(true)
}

  return (
    <div>
        {!isSubmmitted ?
        <div> 
           <GetYourPizza submitForm
          ={submitForm}/> 
        </div>
         : <FormSuccess/>
    }
    </div>
  )
}
